export function convertToCentimeters(ftString: string): number {
  const [feetStr, inchesStr] = ftString.split('.');
  const feet = parseInt(feetStr, 10);
  const inches = parseInt(inchesStr || '0', 10);

  const feetToCm = feet * 30.48;
  const inchesToCm = inches * 2.54;

  return Math.round(feetToCm + inchesToCm);
}
